import {
  CONTAINERS_IMAGE_TAGS_PAGE_LENGTH,
  CONTAINERS_IMAGES_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SEARCH_IMAGE_NAME_QUERY_PARAM,
  SEARCH_TAG_NAME_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from './constants';

const buildQueryString = (params: {
  [key: string]: string | undefined;
}): string => {
  const q = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      q.append(key, value);
    }
  }
  return q.toString();
};

export const urls = {
  api: {
    getImages: (
      workspaceSlug: string,
      sortQueryParam: string | undefined,
      pageQueryParam: string | undefined,
      nameQueryParam: string | undefined
    ): string => {
      const queryString = buildQueryString({
        [PAGELEN_QUERY_PARAM]: CONTAINERS_IMAGES_PAGE_LENGTH.toString(),
        [SORT_QUERY_PARAM]: sortQueryParam,
        [PAGE_QUERY_PARAM]: pageQueryParam,
        [SEARCH_IMAGE_NAME_QUERY_PARAM]: nameQueryParam,
      });

      return `/!api/internal/workspaces/${workspaceSlug}/packages/containers/images?${queryString}`;
    },
    getImageTags: (
      workspaceSlug: string,
      imageName: string,
      sortQueryParam: string | undefined,
      pageQueryParam: string | undefined,
      tagNameQueryParam: string | undefined
    ): string => {
      const queryString = buildQueryString({
        imageName: decodeURIComponent(imageName),
        [PAGELEN_QUERY_PARAM]: CONTAINERS_IMAGE_TAGS_PAGE_LENGTH.toString(),
        [SORT_QUERY_PARAM]: sortQueryParam,
        [PAGE_QUERY_PARAM]: pageQueryParam,
        [SEARCH_TAG_NAME_QUERY_PARAM]: tagNameQueryParam,
      });

      return `/!api/internal/workspaces/${workspaceSlug}/packages/containers/tags?${queryString}`;
    },
    getImageTag: (
      workspaceSlug: string,
      imageName: string,
      tagName: string
    ): string => {
      const queryString = buildQueryString({
        imageName: decodeURIComponent(imageName),
        tagName,
      });

      return `/!api/internal/workspaces/${workspaceSlug}/packages/containers/tag?${queryString}`;
    },
  },
  ui: {
    workspaceContainersImages: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/packages/containers/images`,
    workspaceContainersImageTags: (workspaceSlug: string, imageName: string) =>
      `/${workspaceSlug}/workspace/packages/containers/images/${encodeURIComponent(
        imageName
      )}/tags`,
    workspaceContainersImageTag: (
      workspaceSlug: string,
      imageName: string,
      tagName: string
    ) =>
      `/${workspaceSlug}/workspace/packages/containers/images/${encodeURIComponent(
        imageName
      )}/tags/${tagName}`,
  },
  docs: {
    learnMoreLink: () =>
      'https://support.atlassian.com/bitbucket-cloud/resources/',
  },
};
